import matchEntities from '../shared/entityHelpers';

export default [
  {
    name: 'navigation.block_qwello',
    links: [
      {
        text: 'navigation.experience',
        ref: '/experience',
      },
      {
        text: 'navigation.process',
        ref: '/procesbeschrijving',
        hide: !matchEntities(['NETHERLANDS']),
      },
    ],
  },
  {
    name: 'navigation.block_legal',
    links: [
      {
        text: 'navigation.terms',
        ref: '/terms',
      },
      {
        text: 'navigation.privacy',
        ref: '/privacy',
      },
      {
        text: 'navigation.manual',
        ref: '/manual',
      },
      {
        text: 'navigation.impressum',
        ref: '/impressum',
      },
      {
        text: 'News',
        ref: 'https://qwello.eu/news/',
        isExternal: true,
      },
    ],
  },
  {
    name: 'navigation.block_charging',
    links: [
      {
        text: 'navigation.invoice',
        ref: '/receipt',
      },
      {
        text: 'navigation.transparency',
        ref: '/transparency',
        hide: matchEntities(['POLAND', 'NETHERLANDS']),
      },
    ],
  },
];

export const socialMediaLinks = {
  SWEDEN: {
    qwelloInstagram: 'https://www.instagram.com/qwellosverige/',
    qwelloFacebook: 'https://www.facebook.com/Qwello-Sverige-110785031454734',
  },
  GERMANY: {
    qwelloInstagram: 'https://www.instagram.com/qwello.charge/',
    qwelloFacebook: 'https://www.facebook.com/qwellogermany',
  },
  ITALY: {
    qwelloInstagram: 'https://www.instagram.com/qwello.charge/',
    qwelloFacebook: 'https://www.facebook.com/qwellogermany',
  },
  FRANCE: {
    qwelloInstagram: 'https://www.instagram.com/qwello.france/',
    qwelloFacebook: 'https://www.facebook.com/qwello.france',
  },
  SPAIN: {
    qwelloInstagram: '',
    qwelloFacebook: '',
  },
  UK: {
    qwelloInstagram: 'https://www.instagram.com/qwello.uk/',
    qwelloFacebook: 'https://www.facebook.com/profile.php?id=100095534171860',
  },
  NETHERLANDS: {
    qwelloInstagram: 'https://www.instagram.com/qwello.netherlands/',
    qwelloFacebook: 'https://www.facebook.com/qwello.netherlands',
  },
};
